import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import { Modal } from '../common/modal';
import { NextStep } from '../common/nextStep';
import SizeImage from '../../assets/mtm-size.png';
import ChevRight from '../../assets/ico-chev-right.svg';
import ModalImage1 from '../../assets/image-30.png';
import ModalImage2 from '../../assets/image-31.png';
import ModalImage3 from '../../assets/image-32.png';

import { CustomizeContext } from '../contexts/customize';

const toInch = (cm) => Math.floor(parseInt(cm) * 0.3937 * 100) / 100;

const SizeSection = ({ title, inputName, size, children }) => {
  const [sizeDefault, setSizeDefault] = useState();
  const [sizeDefaultLeft, setSizeDefaultLeft] = useState();
  const [sizeDefaultRight, setSizeDefaultRight] = useState();

  const { customizes, setCustomizes } = useContext(CustomizeContext);

  const iterateOption = (arr, inputName) => {
    if (arr) {
      return arr.options.map((option) => {
        return (
          <>
            {inputName === 'waist_size' ? (
              <>
                {option.value != 2 && (
                  <option value={option.value} key={`option-${option.value}`}>
                    {option.label}
                    {option.is_default === true && <>(default)</>}
                    {option.is_max === true && <>(No Back Darts)</>}
                  </option>
                )}
              </>
            ) : (
              <option value={option.value} key={`option-${option.value}`}>
                {option.is_default === true ? (
                  <>{option.label}(default)</>
                ) : (
                  <>{option.label}</>
                )}
              </option>
            )}
          </>
        );
      });
    }
  };

  const onSelect = (e) => {
    const selectedIndex = e.currentTarget.options.selectedIndex;
    const selectedOption = e.currentTarget.options[selectedIndex].innerHTML;
    const selectName = e.currentTarget.name;
    const inchValue = toInch(selectedOption);

    if (!isNaN(inchValue)) {
      e.target.closest('div').querySelector('.js-to-inch').innerHTML =
        '(' + inchValue + 'inch)';
    }

    if (customizes.sizes[selectName]) {
      if (selectName.includes('left')) {
        customizes.sizes[selectName].id = size.left.id;
      } else if (selectName.includes('right')) {
        customizes.sizes[selectName].id = size.right.id;
      } else {
        customizes.sizes[selectName].id = size.id;
      }

      customizes.sizes[selectName].label = selectedOption;
      customizes.sizes[selectName].value = e.currentTarget.value;

      setCustomizes({ ...customizes });
    }
  };

  useEffect(() => {
    if (inputName === 'sleeve_length' || inputName === 'cuffs_width') {
      size && size.left.default && setSizeDefaultLeft(size.left.default.value);
      size &&
        size.right.default &&
        setSizeDefaultRight(size.right.default.value);
    } else {
      size && size.default && setSizeDefault(size.default.value);
    }
  }, [size]);

  return (
    <div className="row mb-4">
      <div className="col-12 col-lg-3">
        <p className="mtm-size__table__label">{title}</p>
      </div>
      <div className="col">
        <div>
          {inputName === 'sleeve_length' || inputName === 'cuffs_width' ? (
            <>
              <div className="row mb-3">
                <div className="col-2 d-flex align-items-center">Left</div>
                <div className="col">
                  <select
                    className="me-3"
                    name={inputName + '_left'}
                    value={sizeDefaultLeft}
                    onChange={(e) => {
                      onSelect(e);
                      setSizeDefaultLeft(e.currentTarget.value);
                    }}
                  >
                    <option hidden value="">
                      ー
                    </option>
                    {size && iterateOption(size.left)}
                  </select>
                  cm
                  <span className="ms-2 js-to-inch">
                    {size &&
                      size.left.default &&
                      size.left.default.label &&
                      `(${toInch(size.left.default.label)} inch)`}
                  </span>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-2 d-flex align-items-center">Right</div>
                <div className="col">
                  <select
                    className="me-3"
                    name={inputName + '_right'}
                    value={sizeDefaultRight}
                    onChange={(e) => {
                      onSelect(e);
                      setSizeDefaultRight(e.currentTarget.value);
                    }}
                  >
                    <option hidden value="">
                      ー
                    </option>
                    {size && iterateOption(size.right)}
                  </select>
                  cm
                  <span className="ms-2 js-to-inch">
                    {size &&
                      size.right.default &&
                      size.right.default.label &&
                      `(${toInch(size.right.default.label)} inch)`}
                  </span>
                </div>
              </div>
            </>
          ) : (
            <>
              <select
                className="me-3"
                name={inputName}
                value={sizeDefault}
                onChange={(e) => {
                  onSelect(e);
                  setSizeDefault(e.currentTarget.value);
                }}
              >
                <option hidden value="">
                  ー
                </option>
                {iterateOption(size, inputName)}
              </select>
              cm
              <span className="ms-2 js-to-inch">
                {size &&
                  size.default &&
                  size.default.label &&
                  `(${toInch(size.default.label)} inch)`}
              </span>
            </>
          )}
        </div>
        <div className="mtm-size__table__caption">{children}</div>
      </div>
    </div>
  );
};

const MtmSize = () => {
  const [baseSize, setBaseSize] = useState();
  const [sizes, setSizes] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [variant, setVariant] = useState();
  const [modalTrigger, setModalTrigger] = useState();

  const { customizes, setCustomizes } = useContext(CustomizeContext);

  const openModal = (e) => {
    setModalTrigger(e.target.id);
    setIsShow(true);
  };

  const ids = {
    chest_size: 'G02',
    collar_size: 'G01',
    body_length: 'L01',
    sleeve_length_left: 'L03',
    sleeve_length_right: 'L04',
    cuffs_width_left: 'W03',
    cuffs_width_right: 'W04',
    waist_size: 'G03',
    yoke_size: 'W01',
    sleeve_width: 'W06'
  };

  const baseURL = process.env.REACT_APP_API_URL;
  const productId = document.getElementById('mtm-customize').dataset.productId;

  const filterSize = (arr, id) => {
    const sizeObj = arr.filter((size) => size.id === id)[0];

    if (sizeObj) {
      sizeObj.default = sizeObj.options.filter((opt) => opt.is_default)[0];
      return sizeObj;
    }
  };

  useEffect(() => {
    const client = axios.create({
      baseURL: baseURL + '/get_product_skus'
    });

    const getBase = async () => {
      const responseBase = await client.get('?product_id=' + productId);
      const baseSize = responseBase.data.results;
      setBaseSize(baseSize);
    };
    getBase();
  });

  useEffect(() => {
    const client = axios.create({
      baseURL: baseURL + '/get_corrected_size'
    });

    setSizes({ base: baseSize });

    const getSize = async () => {
      const response = await client.get(
        '?product_id=' + productId + '&id=' + variant.id + '&back_id=' + customizes.back.id + '&back_value=' + customizes.back.value
      );
      const result = response.data.result;
      const sizes = {
        base: baseSize,
        chest_size: filterSize(result, ids.chest_size),
        collar_size: filterSize(result, ids.collar_size),
        body_length: filterSize(result, ids.body_length),
        sleeve_length: {
          left: filterSize(result, ids.sleeve_length_left),
          right: filterSize(result, ids.sleeve_length_right)
        },
        cuffs_width: {
          left: filterSize(result, ids.cuffs_width_left),
          right: filterSize(result, ids.cuffs_width_right)
        },
        waist_size: filterSize(result, ids.waist_size),
        yoke_size: filterSize(result, ids.yoke_size),
        sleeve_width: filterSize(result, ids.sleeve_width)
      };

      setSizes(sizes);

      // customizeのcontextにサイズ情報を更新
      const contextSizes = {
        base: variant,
        chest_size: {
          id: sizes.chest_size.id,
          label: sizes.chest_size.default && sizes.chest_size.default.label,
          value: sizes.chest_size.default && sizes.chest_size.default.value
        },
        collar_size: {
          id: sizes.collar_size.id,
          label: sizes.collar_size.default && sizes.collar_size.default.label,
          value: sizes.collar_size.default && sizes.collar_size.default.value
        },
        body_length: {
          id: sizes.body_length.id,
          label: sizes.body_length.default && sizes.body_length.default.label,
          value: sizes.body_length.default && sizes.body_length.default.value
        },
        sleeve_length_left: {
          id: sizes.sleeve_length.left.id,
          label:
            sizes.sleeve_length.left.default &&
            sizes.sleeve_length.left.default.label,
          value:
            sizes.sleeve_length.left.default &&
            sizes.sleeve_length.left.default.value
        },
        sleeve_length_right: {
          id: sizes.sleeve_length.right.id,
          label:
            sizes.sleeve_length.right.default &&
            sizes.sleeve_length.right.default.label,
          value:
            sizes.sleeve_length.right.default &&
            sizes.sleeve_length.right.default.value
        },
        cuffs_width_left: {
          id: sizes.cuffs_width.left.id,
          label:
            sizes.cuffs_width.left.default &&
            sizes.cuffs_width.left.default.label,
          value:
            sizes.cuffs_width.left.default &&
            sizes.cuffs_width.left.default.value
        },
        cuffs_width_right: {
          id: sizes.cuffs_width.right.id,
          label:
            sizes.cuffs_width.right.default &&
            sizes.cuffs_width.right.default.label,
          value:
            sizes.cuffs_width.right.default &&
            sizes.cuffs_width.right.default.value
        },
        waist_size: {
          id: sizes.waist_size.id,
          label: sizes.waist_size.default && sizes.waist_size.default.label,
          value: sizes.waist_size.default && sizes.waist_size.default.value
        },
        yoke_size: {
          id: sizes.yoke_size.id,
          label: sizes.yoke_size.default && sizes.yoke_size.default.label,
          value: sizes.yoke_size.default && sizes.yoke_size.default.value
        },
        sleeve_width: {
          id: sizes.sleeve_width.id,
          label: sizes.sleeve_width.default && sizes.sleeve_width.default.label,
          value: sizes.sleeve_width.default && sizes.sleeve_width.default.value
        }
      };
      setCustomizes({ ...customizes, sizes: { ...contextSizes } });
    };

    if (variant) getSize();
  }, [variant, customizes.back.id, customizes.back.value]);

  return (
    <div className="mtm-item__wrapper" id="mtm-size">
      <h3 className="mtm-item__title">SIZE</h3>
      <div className="row">
        <div className="col-12 col-md-4 mtm-size__image">
          <img src={SizeImage} alt="mtm-size" />
          <p className="text-right mt-3">
            <a
              href="https://kamakurashirts.com/pages/size-guide"
              target="_blank"
            >
              Size Chart <img src={ChevRight} />
            </a>
          </p>
          <p className="text-right">
            <a onClick={openModal} id="measure">
              How To Measure <img src={ChevRight} />
            </a>
          </p>
          <Modal
            isShow={isShow && modalTrigger === 'measure'}
            setIsShow={setIsShow}
            isCloseInside
          >
            <div className="mtm-size__modal">
              <div className="mtm-size__modal--wrapper">
                <h3 className="mtm-size__modal--title mb-4">How To Measure</h3>
                <div className="mtm-size__modal--meta mb-4">
                  <div className="mb-2">1.Neck</div>
                  <p>
                    Measuring your own neck for this is recommended. Measure
                    your neck tightly, right below your Adam's apple where the
                    collar of your shirt would sit. Put room for two fingers
                    between your neck and tape, then note the measurement.
                  </p>
                </div>
                <div className="mtm-size__modal--meta mb-4">
                  <div className="mb-2">2. Sleeve</div>
                  <p>
                    Measure on the back from the middle of the shirt, at the
                    base of the collar. Go along the yoke, then pivot from the
                    shoulder down to the outer edge of the cuff.
                  </p>
                </div>
                <div className="mtm-size__modal--wrap d-flex">
                  <img src={ModalImage1} alt="How To Measure" />
                  <img src={ModalImage2} alt="How To Measure" />
                  <img src={ModalImage3} alt="How To Measure" />
                </div>
              </div>
            </div>
          </Modal>
        </div>
        <div className="col-12 col-md-8 mtm-size__input ps-3 ps-lg-5">
          <div className="row mb-4">
            <div className="col-12 col-lg-3">
              <p className="mtm-size__table__label">Base Size</p>
            </div>
            <div className="col">
              <div>
                <select
                  className="me-3"
                  onChange={(e) => {
                    const selectedIndex = e.currentTarget.options.selectedIndex;
                    const selectedOption =
                      e.currentTarget.options[selectedIndex].innerHTML;
                    setVariant({
                      id: e.currentTarget.value,
                      label: selectedOption
                    });
                  }}
                >
                  <option hidden value="">
                    ー
                  </option>
                  {baseSize &&
                    baseSize.map((el) => (
                      <option value={el.id} key={`variant-${el.id}`}>
                        {el.value}
                      </option>
                    ))}
                </select>
                <a onClick={openModal} id="size">
                  About Base Size <img src={ChevRight} />
                </a>
                <Modal
                  isShow={isShow && modalTrigger === 'size'}
                  setIsShow={setIsShow}
                  isCloseInside
                >
                  <div className="mtm-size-small__modal p-4 p-md-5">
                    <div className="mtm-size-small__modal--wrapper">
                      <div className="mtm-size-small__modal--title mb-4">
                        <h3 className="m-0">
                          What is a base size{' '}
                          <span className="mtm-size-icon">?</span>
                        </h3>
                      </div>
                      <div className="mb-3">
                        <div className="mtm-size-small__modal--meta">
                          It is the size based on Kamakura Shirt's off the rack
                          products.
                        </div>
                      </div>
                      <div className="mtm-size-small__modal--meta small">
                        <p>
                          Example: A customer who normally wears a classic fit
                          [40-82] will have the standard size [40-82]. (The base
                          length of the shirt is 81 cm, the base sleeve length
                          is 82.0 cm, and the cuffs are 22 cm.
                        </p>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>
              <div className="mtm-size__table__caption">
                <p>
                  Your base size is based on the ready-made Kamakura Shirts.
                  <br />
                  Take a look at our size chart here.
                </p>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-12 col-lg-3">
              <p className="mtm-size__table__label">Chest Size</p>
            </div>
            <div className="col">
              {sizes.chest_size && sizes.chest_size.default.label}cm (
              {sizes.chest_size && toInch(sizes.chest_size.default.label)} inch)
              <p className="mtm-size__table__caption--sm">
                ＊Chest_size size cannot be adjusted.
              </p>
            </div>
          </div>
          <SizeSection
            title="Collar Size"
            inputName="collar_size"
            size={sizes.collar_size}
            key={sizes.id}
          >
            <p>
              Measuring your own neck for this is recommended.
              <br />
              Measure your neck tightly, right below your Adam's apple where the
              collar of your shirt would sit.
            </p>
            <p>
              Put room for two fingers between your neck and tape, then note the
              measurement.
              <br />
              The actual sleeve length will be increased by 0.8 cm in
              consideration of shrinkage.
            </p>
          </SizeSection>
          <SizeSection
            title="Body Length"
            inputName="body_length"
            size={sizes.body_length}
            key={sizes.id}
          >
            <p>
              Measure on the back side of the shirt, from the center of the back
              of the collar to the hem of the garment.
            </p>
          </SizeSection>
          <SizeSection
            title="Sleeve Length"
            inputName="sleeve_length"
            size={sizes.sleeve_length}
            key={sizes.id}
          >
            <p>
              The actual sleeve length will be increased by 1.5 cm in
              consideration of shrinkage.
            </p>
            <p>
              <strong>How to measure:</strong>
              <br />
              Measure on the back from the middle of the shirt, at the base of
              the collar.
              <br />
              Go along the yoke, then pivot from the shoulder down to the outer
              edge of the cuff.
            </p>
          </SizeSection>
          {/* NOTE: Monograms と Label の非表示によるコメントアウト
          <SizeSection
            title="Cuffs Width"
            inputName="cuffs_width"
            size={sizes.cuffs_width}
            key={sizes.id}
          >
            <p>
              The cuff width is the width from the center of the button to far
              end of the buttonhole.
            </p>
          </SizeSection>
          <SizeSection
            title="Waist"
            inputName="waist_size"
            size={sizes.waist_size}
          >
            <p>
              Tokyo Slim Fit / NY Slim Fit have darts on the back, which can be
              corrected to adjust the waist.
              <br />
              Adjustments can be made starting with -2 cm, -4 cm, -6 cm*. It is
              possible to get rid of the darts to add 4 cm in the waist.
              <br />
              *To adjust -6 cm, the adjustment is made by deeply sewing the back
              darts by - 1cm on each side.
            </p>
            <p>
              Please note that waists that have box pleats (Slim Fit Button Down
              shirts, Classic Fit shirts, 134 Casual fits) cannot be adjusted.
            </p>
          </SizeSection>
          <SizeSection
            title="Yoke"
            inputName="yoke_size"
            size={sizes.yoke_size}
            key={sizes.id}
          >
            <p>Shoulder width can be adjusted up to + -1 cm.</p>
          </SizeSection>
          <SizeSection
            title="Sleeve Width"
            inputName="sleeve_width"
            size={sizes.sleeve_width}
            key={sizes.id}
          >
            <p>
              Sleeve width (about 20 cm from the upper arm / top of the
              shoulder) can be corrected by -1 cm. Arm holes cannot be
              corrected.
            </p>
          </SizeSection>
          */}
        </div>
      </div>
      {/* NOTE: Monograms と Label の非表示によるコメントアウト
        <NextStep /> 
      */}
    </div>
  );
};

export default MtmSize;
